export const AGENT = {
  roleId: 1,
};
export const MANAGER = {
  roleId: 2,
};
export const FINANCE = {
  roleId: 3,
};
export const DIRECTOR = {
  roleId: 4,
};
export const INFORMATION_AGENT = {
  roleId: 5,
};
export const ADMINISTRATOR = {
  roleId: 6,
};
export const PLAN_ADMINISTRATOR = {
  roleId: 7,
};
export const FINTECH = {
  roleId: 8,
};
export const HR_CLERK = {
  roleId: 9,
};
export const HIGH_MANAGEMENT = [ADMINISTRATOR, FINTECH, DIRECTOR];
export const HIGH_MANAGEMENT_WITHOUT_DIRECTOR = [ADMINISTRATOR, FINTECH];
export const HIGH_MANAGEMENT_WITH_FINANCE = [...HIGH_MANAGEMENT, FINANCE];
export const HIGH_MANAGEMENT_WITH_MANAGER = [...HIGH_MANAGEMENT, MANAGER];
export const HIGH_MANAGEMENT_WITH_FINANCE_AND_MANAGER = [...HIGH_MANAGEMENT_WITH_FINANCE, MANAGER];
export const ALL_ROLES_WITHOUT_AGENT = [...HIGH_MANAGEMENT_WITH_FINANCE_AND_MANAGER, PLAN_ADMINISTRATOR, INFORMATION_AGENT];
export const INTERNAL_ROLES = [...HIGH_MANAGEMENT_WITH_FINANCE_AND_MANAGER, AGENT];
export const EXTERNAL_ROLES = [PLAN_ADMINISTRATOR, INFORMATION_AGENT, HR_CLERK];



// WEBPACK FOOTER //
// ./src/utils/Roles.js